<template>
  <section v-if='kql.page' class='main'>
    <Playlist :playlist='kql.site?.content?.playlist' :context='kql.site' />
    <!--<Drawing src='esapekkasalonen.com-1.png' />-->
    <HeroImage :selection='kql?.site?.content?.cover' :sources='kql.page.images' v-scene data-scene="distortAScatter"/>

    <hr v-scene data-scene="blend"/>

    <Events :max='3' class='events' v-scene data-scene="distortAScatter"/>

    <footer class='calendar' v-scene data-scene="square">
      <h3>
        See more future events in the <a href='/calendar'>Calendar</a>
      </h3>
    </footer>

    <Clocks class='clocks' v-scene data-scene="distortAOrganic"/>

    <hr class='pause' v-scene data-scene="">


    <hr class='pause' v-scene data-scene="">


    <Timeline :timelineitems='timelineitems' :categorypages='categorypages' v-scene data-scene="distortAScatterWide"/>
    <!--<Shader id='shader' v-if='kql.page.content' :fragmentShader='fragmentShader' :time='1.' :ratio='true' :scroll='true' />-->
    <MainFooter  v-scene data-scene="distortB"/>
  </section>
</template>
<script setup>
  //import fragmentShader from '@/components/glsl/stars.frag'
  import { useStore } from '@/KQL.js'
  import Events from '@/components/Sections/Events.vue'
  import { yamlToArray, pageFromPath, filterPublicPages } from '@/utils'
  const kql = useStore();
  const categoryids = computed(()=> yamlToArray(kql.site.content?.categoryparents));
  const categorypages = computed(()=> categoryids.value.map(item => pageFromPath(item, kql.pages)));
  const timelineitems = computed(()=> categorypages.value.reduce((accumulator, item) => {
    return accumulator.concat(filterPublicPages(item?.children) || []);
  }, []));
</script>

<style>
  body {
    background-color: black;
  }
</style>

<style scoped>
  hr {
    display: block;
    height: 3rem;
    margin: 0;
    border: none;
    outline: none;
  }

  hr.pause {
    height: 12rem;
  }

  section > * {
    /*background-color: red;*/
  }

  #shader {
    top: 0rem;
    bottom: 0rem;
    left: 0rem;
    right: 0rem;
    position: fixed;
    margin: auto;
    width: 100vw;
    overflow: hidden;
  }

  section.main {
    background-color: black;
  }

  section.clocks {
    padding-top: 40rem;
    padding-bottom: 40rem;
  }

  footer.calendar {
    padding-top: 20rem;
    padding-bottom: 20rem;
  }

  footer.calendar h3 {
    margin: auto;
    margin-top: 6rem;
    margin-bottom: 2rem;
    box-sizing: border-box;
    padding: 2rem;
    width: 100%;
    text-align: center;
    font-style: italic;
  }

  footer.calendar h3 a {
    font-style: normal;
    position: relative;
    cursor: pointer;
  }

  footer.calendar a::before {
    position: absolute;
    bottom: -0.05em;
    left: 0;
    content: '';
    background: var(--light);
    height: 0.01em;
    width: calc(100%);
    transform: scalex(0);
    transform-origin: 0;
    transition: transform .4s ease;
  }
  section > footer a:hover::before {
    transform: scalex(1);
  }
</style>
